import { useEffect, useState } from 'react';

/** Returns `value`, but holds the previous value for `ms` after each change (0 = immediately); a further change restarts the hold. */
export function useSettled<T>(value: T, ms: number): T {
  const [shown, setShown] = useState(value);
  useEffect(() => {
    if (ms <= 0) { setShown(value); return; }
    const t = window.setTimeout(() => setShown(value), ms);
    return () => window.clearTimeout(t);
    // ms is read when the value changes; a later change of ms alone must not restart the hold
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return shown;
}
